/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 rack6slot2.glb --transform --simplify --ratio 0.5 --draco 
Files: rack6slot2.glb [3.59MB] > C:\Users\eduardo.vieira\OneDrive - Evoleo Technologies, Lda\Desktop\NEWMODELSORION\rack6slot2-transformed.glb [268.91KB] (93%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function Rack6slotModel(pos)  {
  const { nodes, materials } = useGLTF('/models/rack6slot2-transformed.glb')
  return (
    <group position={[76,-8.5,2]} dispose={null} rotation={[Math.PI/2,0,0]} >
      <mesh geometry={nodes.TAMPA_1.geometry} material={materials.PaletteMaterial001} />
      <mesh geometry={nodes.TAMPA_2.geometry} material={materials.PaletteMaterial002} />
    </group>
  )
}

useGLTF.preload('/models/rack6slot2-transformed.glb')
